import { createComponent } from '@mtfe/sweet';
import { eventBus, common, dom, createObserve } from '@mtfe/sweet-utils';

import style from './style.less';
import useTpl from './useCouponList.html';
import showTpl from './showCouponList.html';
import { COUPON_STATUS, COUPON_TYPE } from '../constants/index';
import componentUtils from '../utils/index';

const { createUniqueId, isFunction } = common;
const { getGiftEventName, Describe } = componentUtils;

const COMPONENT_ID = 'waimai_zm5h0s7f';
const SUB_COMPONENT_COUPON_ID = 'waimai_4f3ioj7z';
const SUB_COMPONENT_RECEIVE_ALL_ID = 'waimai_z081wh0b';

const describeCouponListD = new Describe('CouponListD', COMPONENT_ID);
const describeCoupon = new Describe('Coupon', SUB_COMPONENT_COUPON_ID);
const describeReceiveAll = new Describe(
    'ReceiveAll',
    SUB_COMPONENT_RECEIVE_ALL_ID,
);

describeCouponListD.setSubComponent('Coupon', describeCoupon);
describeCouponListD.setSubComponent('ReceiveAll', describeReceiveAll);

class CouponListD {
    constructor(props = {}) {
        this.uniqueId = createUniqueId();
        this.propsCache = {};
        this.component = this.createDom(props);
        this.readyEventName = `ready_${this.uniqueId}`;
        this.describe = describeCouponListD;
    }
    createDom = (newProps) => {
        this.propsCache = { ...this.propsCache, ...newProps };
        const {
            couponList = [],
            giftValue,
            isIgnoreRedBag = false,
            isShowSmall = false,
        } = this.propsCache;
        const {
            title = '惊喜券包',
            subtitle = `共${couponList.length}张券`,
            buttonWriting = '立即领取',
        } = this.propsCache;
        const { onCouponClick, onGetAllCouponsClick } = this.propsCache;

        const showList = isIgnoreRedBag
            ? couponList.filter((poiInfo) => {
                  const { giftInfo } = poiInfo;
                  return giftInfo.type === COUPON_TYPE.SHOP_COUPON;
              })
            : couponList;

        const isCouponReceived = showList.filter((poiInfo) => {
            const { giftInfo } = poiInfo;
            return giftInfo.status === COUPON_STATUS.STATUS_RECEIVED;
        });

        const tpl = isCouponReceived.length ? useTpl : showTpl;
        style.showCoupons = isShowSmall
            ? style.showCouponsSmall
            : style.showCoupons;
        style.useCoupons = isShowSmall
            ? style.useCouponsSmall
            : style.useCoupons;
        const data = {
            uniqueId: this.uniqueId,
            showList,
            title,
            subtitle,
            giftValue,
            buttonWriting,
            COUPON_STATUS,
            COUPON_TYPE,
        };
        const events = {
            onGetAllCouponsClick: () => {
                if (isFunction(onGetAllCouponsClick)) {
                    onGetAllCouponsClick.call(this);
                }
            },
            onCouponClick: (index) => {
                if (isFunction(onCouponClick)) {
                    onCouponClick(couponList[index], index);
                }
            },
        };
        eventBus.clearEvent(this.readyEventName);
        eventBus.$on(this.readyEventName, this.ready.bind(this));
        couponList.forEach((poiInfo) => {
            if (poiInfo.giftInfo) {
                const { gift_id: giftId } = poiInfo.giftInfo;
                const eventName = getGiftEventName(giftId);
                eventBus.$on(eventName, (newStatus) => {
                    const selector = `#${this.uniqueId} [data-gift-id=gift-id${giftId}]`;
                    const btnDomList = Array.from(
                        document.querySelectorAll(selector),
                    );
                    if (btnDomList.length) {
                        btnDomList.forEach((btnDom) => {
                            if (newStatus === COUPON_STATUS.STATUS_NEW) {
                                btnDom.innerText = '去领取';
                                poiInfo.giftInfo.status =
                                    COUPON_STATUS.STATUS_NEW;
                            } else if (
                                newStatus === COUPON_STATUS.STATUS_RECEIVED
                            ) {
                                btnDom.innerText = '去使用';
                                poiInfo.giftInfo.status =
                                    COUPON_STATUS.STATUS_RECEIVED;
                            }
                        });
                    }
                });
            }
        });
        const component = createComponent(tpl, { data, style }, events);
        return component;
    };
    getComponent = () => {
        return this.component;
    };
    render(newProps) {
        const container = dom.$id(this.uniqueId);
        this.component = this.createDom(newProps);
        container.outerHTML = this.component;
    }
    ready() {
        const { isMonitorCoupons = false, http, couponList } = this.propsCache;
        if (!http) {
            throw new Error('');
        }
        if (isMonitorCoupons) {
            const couponDomList = Array.from(
                document.querySelectorAll(
                    `#${this.uniqueId} [coupon-monitor-index]`,
                ),
            );
            const observeCb = async (err, item) => {
                if (err) {
                    console.log('CouponListD 组件券曝光监控失败', err);
                    return;
                }
                // TODO
                const componentId = '';
                try {
                    const currentIndex = item.target.getAttribute(
                        'coupon-monitor-index',
                    );
                    const url = `${couponList[currentIndex].impMonitorUrl}&componentId=${componentId}`;
                    await http.gMonitorApi(url);
                } catch (error) {
                    console.log('CouponListD 组件券曝光上报失败', error);
                }
            };
            if (couponDomList.length) {
                createObserve(observeCb, couponDomList);
            }
        }
    }
}

export default CouponListD;
